import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Image from "../assets/Hand.png";
import User from "../assets/User.png";
import Data from "../assets/Data.png";
import Cloud from "../assets/Cloud.png";
import Cyber from "../assets/Cyber.png";
import { NavLink } from "react-router-dom";

const Solutiions = () => {
  const profileStyle = {
    height: "50px",
    width: "50px",
    borderRadius: "50%",
    objectFit: "cover",
  };
  const cardStyle = {
    background: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    padding: "10px",
    height: "430px",
    color: "white",
  };
  const buttonStyle = {
    bottom: "10px",
    right: "10px",
    border: "none",
    background: "transparent",
    color: "white",
    textDecoration: "underline",
    marginRight: "15px",
  };
  return (
    <Container
      fluid
      style={{
        color: "white",
        backgroundColor: "#214D6E",
        backgroundImage: `url(${Image})`,
        backgroundSize: "contain",
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",
        minHeight: "105vh",
      }}
    >
      <Row>
        <Col md={6}>
          <div className="mt-5 ms-5">
            <h1 className="display-4">We offer a variety of Solutions.</h1>
          </div>
        </Col>
        <Col></Col>
      </Row>
      <Row xs={1} md={2} lg={4} className="mt-5">
        <Col>
          <Card className="mt-1 mb-2 hover-top" style={cardStyle}>
            <Card.Body>
              <img
                className="border border-dark ms-3 mt-3"
                style={profileStyle}
                src={User}
                alt="Identity Governance and Administration"
              />
              <div className="ms-3 mt-4">
                <span>
                  <h5>Identity Governance and Administration</h5>
                </span>
                <p>
                 Our Identity Governance and Administration solutions enable organizations to effectively manage user identities and access privileges. By automating workflows, enforcing policies, and ensuring compliance.
                </p>
              </div>
              <Button as={NavLink} to={"/id&a"} className="position-absolute" style={buttonStyle}>
                See More &rarr;
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="mt-1 mb-2 hover-top" style={cardStyle}>
            <Card.Body>
              <img
                className="border border-dark ms-3 mt-3"
                style={profileStyle}
                src={Cyber}
                alt="Access Management"
              />
              <div className="ms-3 mt-4">
                <span>
                  <h5>Access Management</h5>
                </span>
                <p>
                 With IDM 360 Analytics, We offers end-to-end Access Management solutions that safeguard your data by controlling user access with precision. we ensure your systems remain secure, while users have seamless access to the resources they need.
                </p>
              </div>
              <Button as={NavLink} to={"/access-m"} className="position-absolute" style={buttonStyle}>
                See More &rarr;
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="mt-1 mb-2 hover-top" style={cardStyle}>
            <Card.Body>
              <img
                className="border border-dark ms-3 mt-3"
                style={profileStyle}
                src={Cloud}
                alt="Multi-Factor Authentication"
              />
              <div className="ms-3 mt-4 ">
                <span>
                  <h5>Multi-Factor Authentication</h5>
                </span>
                <p>
                  We provide advanced Multi-Factor Authentication solutions designed to strengthen your organization’s security posture by requiring multiple layers of identity verification. This approach ensures secure access for authorized users only.
</p>
              </div>
              <Button as={NavLink} to={"/m-fa"} className="position-absolute" style={buttonStyle}>
                See More &rarr;
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="mt-1 mb-2 hover-top" style={cardStyle}>
            <Card.Body>
              <img
                className="border border-dark ms-3 mt-3"
                style={profileStyle}
                src={Data}
                alt="Priviledge Acess Management"
              />
              <div className="ms-3 mt-4">
                <span>
                  <h5>Privilege Access Management</h5>
                </span>
                <p>
                 Our Privilege Access Management solutions are designed to control and monitor the access of critical systems and sensitive data. By managing privileged accounts, enforcing the principle of least privilege, and continuously auditing access.
                </p>
              </div>
              <Button as={NavLink} to={"/pam"} className="position-absolute" style={buttonStyle}>
                See More &rarr;
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Solutiions;
